import React, { createContext, useState } from 'react';

const RoomsContext = createContext();

export const RoomsProvider = ({ children }) => {
    const [rooms, setRooms] = useState([{ adultsCount: 2, childrenCount: 0, isInCart: false, roomNumber: 1 }]);

    const updateRoom = (roomNumber, isInCart) => {
        setRooms((prevRooms) =>
            prevRooms.map((room) =>
                room.roomNumber === roomNumber
                    ? { ...room, isInCart }
                    : room
            )
        );
    };

    return (
        <RoomsContext.Provider value={{ rooms, setRooms, updateRoom }}>
            {children}
        </RoomsContext.Provider>
    );
};

export default RoomsContext;